import {FC, useContext} from "react";
import {useNavigate} from "react-router-dom";
import {IAdminUsersQuizzesResponseEntry, ILocalizationEntity} from "@buildwitt/shapeshift-types";
import {useApi} from "@buildwitt/shapeshift-identity";
import {AdminTable, AdminTableProps} from "@/components/common/table";
import {GRID_CHECKBOX_SELECTION_COL_DEF} from "@mui/x-data-grid-pro";
import { PageBaseContext } from "@/contexts/pageBaseContext";

const headCells = (locales?: ILocalizationEntity[], ownedCohortTitle?: string): AdminTableProps<"quiz", IAdminUsersQuizzesResponseEntry>["columns"] => ([
	{
		...GRID_CHECKBOX_SELECTION_COL_DEF,
		type: "string",
		hideable: false
	},
	{
		field: "title",
		type: "string",
		flex: 1,
		headerName: "Quiz",
		minWidth: 240
	},
	{
		field: "publishedAt",
		type: "date",
		flex: 1,
		headerName: "Published",
		width: 100,
		valueGetter: (e) => e.value ? new Date(e.value).toLocaleDateString() : ""
	},
	{
		field: "languages",
		type: "string",
		filterable: false,
		flex: 1,
		headerName: "Supported Languages",
		valueGetter: ({value}: {value: IAdminUsersQuizzesResponseEntry["languages"]}) => value?.map(e => locales?.find(x => x.code === e)?.name)?.join(", ")
	}
	// {
	// 	field: "authorCohort",
	// 	type: "string",
	// 	flex: 1,
	// 	filterable: false,
	// 	headerName: "Shared By",
	// 	valueGetter: ({value}: {value: IAdminUsersQuizzesResponseEntry["authorCohort"]}) => (value?.title ?? "") === ownedCohortTitle ? "" : value?.title
	// }
]);

type IProps = Partial<AdminTableProps<"quiz", IAdminUsersQuizzesResponseEntry>>;

export const AdminQuizzesTable: FC<IProps> = (baseProps) => {
	const navigate = useNavigate();
	const [locales] = useApi<ILocalizationEntity[]>("/api/settings/i18n");
	const [{ownedCohort}] = useContext(PageBaseContext)

	return (
		<AdminTable<"quiz", IAdminUsersQuizzesResponseEntry>
			url="/api/strapi-plugin-shapeshift-lms/cohort/quiz"
			columns={headCells(locales.data, typeof ownedCohort === "object" ? ownedCohort?.title : undefined)}
			enableDelete
			type="quiz"
			filterSettingsPersistenceStorageKey="quizFilterSettings"
			onEditAction={e => navigate(e.id.toString())}
			{...baseProps}
		/>
	);
}
